import { plolawat, acv, skPolymer, adbSealant, advanceAutoSupply, cjManufacturing, seiKenheiMark, perfectRubberParts, proPartDistributor, vpsEquipment, jungle4x4, odAndLeo, sahamitrPressureContainer, mccIndustrian, luckyFlame, spr, innovekAsia, mrWheel } from "../assets";

const thaiDelegationList2025Industry = [
  // Automotive / Auto Parts and Accessories
  {
    sector: "Automotive / Auto Parts and Accessories",
    sectorEs: "Automotriz / Autopartes y Accesorios",
    brand: ["S.K. POLYMER"],
    logo: skPolymer,
    url: "https://skpolymer.com/",
    catalogUrl: "https://drive.google.com/file/d/14sAEEBt0EjstnW28_cmPQ43hqZejQwEi/view?usp=sharing",
    description: "Seal plug, grommet mounting compressor, rubber speed bump, rubber wheel stop, rubber cap end, rubber groomet, O-ring, rubber parts for medical and electrical appliances.",
    descriptionEs: "Tapones, soportes de goma para compresores, topes y reductores de velocidad, piezas de goma para industria médica y electrodomésticos."
  },
  {
    sector: "Automotive / Auto Parts and Accessories",
    sectorEs: "Automotriz / Autopartes y Accesorios",
    brand: ["ADB"],
    logo: adbSealant,
    url: "https://www.adbs.co.th",
    catalogUrl: "https://drive.google.com/file/d/1puh_2_lBmNj8mujdaK5bbCWqyY6ouU2W/view?usp=sharing",
    description: "Silicone Sealant for automotive maintenance and home repairs.",
    descriptionEs: "Sellador de silicona para mantenimiento automotriz y reparaciones del hogar."
  },
  {
    sector: "Automotive / Auto Parts and Accessories",
    sectorEs: "Automotriz / Autopartes y Accesorios",
    brand: ["KAWAMA"],
    logo: plolawat,
    url: "https://www.polawatengine.co.th",
    catalogUrl: "https://drive.google.com/file/d/1CXZRYgy0pN0gUseb7nwjh5eqAkBk0i_S/view?usp=sharing",
    description: "Diesel engine, gasoline engine, water pump, generator, power sprayer, brush cutter.",
    descriptionEs: "Motores diésel y nafteros, bombas de agua, generadores, pulverizadores y desmalezadoras."
  },
  {
    sector: "Automotive / Auto Parts and Accessories",
    sectorEs: "Automotriz / Autopartes y Accesorios",
    brand: ["SKHM", "SEIKENHEI"],
    logo: seiKenheiMark,
    url: "http://www.seikenhei.co.th/",
    catalogUrl: "https://drive.google.com/file/d/1B5SXuKn1JMG-9V6lu3ZqCt1eLErjq7Dw/view?usp=sharing",
    description: "Car floor mat, mudflap, mudguard, plastic part, rubber part.",
    descriptionEs: "Alfombras, guardabarros, piezas plásticas y de goma para autos y pickups."
  },
  {
    sector: "Automotive / Auto Parts and Accessories",
    sectorEs: "Automotriz / Autopartes y Accesorios",
    brand: ["PERFECT RUBBER PARTS"],
    logo: perfectRubberParts,
    url: "https://perfectrubberparts.com",
    catalogUrl: "https://drive.google.com/file/d/11yS24-Hm9ZU-wV7n9pdsfwE-5U3dNy_k/view?usp=sharing",
    description: "Arm bushing, engine mounting, drive shaft boots, shock absorber mounting, center bearing, stabilizer shaft rubber.",
    descriptionEs: "Bujes, soportes de motor, fuelles, soportes de amortiguador, rulemanes y gomas estabilizadoras."
  },
  {
    sector: "Automotive / Auto Parts and Accessories",
    sectorEs: "Automotriz / Autopartes y Accesorios",
    brand: ["POWER-S", "Air/Oil/Fuel Filter"],
    logo: proPartDistributor,
    url: "https://propartdistributor.com",
    catalogUrl: "https://drive.google.com/file/d/1wT1KO6I-GUSH35KQg5u4kZeN1eX7iLbM/view?usp=sharing",
    description: "Auto filter, oil filter, fuel filter, other auto parts component.",
    descriptionEs: "Filtros de aire, aceite y combustible, y otros componentes para autos."
  },
  {
    sector: "Automotive / Auto Parts and Accessories",
    sectorEs: "Automotriz / Autopartes y Accesorios",
    brand: ["SMPC / Customer Brand"],
    logo: sahamitrPressureContainer,
    url: "https://www.smpcplc.com/",
    catalogUrl: "https://drive.google.com/file/d/1yHZTgrgOiXTVvcmaqM5vDdJvCKukwdYE/view?usp=sharing",
    description: "RV tank, steel & aluminum forklift cylinders, LPG cylinders, steel options with zinc coating, aluminum types with clear finish.",
    descriptionEs: "Tanques RV, cilindros de acero y aluminio para autoelevadores, cilindros de gas, opciones con recubrimiento de zinc."
  },
  {
    sector: "Automotive / Auto Parts and Accessories",
    sectorEs: "Automotriz / Autopartes y Accesorios",
    brand: ["ADVANCE AUTO SUPPLY "],
    logo: advanceAutoSupply,
    url: "https://www.advanceauto.co.th",
    catalogUrl: "https://drive.google.com/file/d/1o5f4_gOlD-UkdcyqIx99KYvbXO9o-29C/view?usp=sharing",
    description: "Rubber weatherstrips for car windows, doors, plastic inner fender liner, universal weatherstrip for Japanese cars.",
    descriptionEs: "Burletes de goma para ventanas y puertas, guardabarros plásticos, burletes universales para autos japoneses."
  },
  {
    sector: "Automotive / Auto Parts and Accessories",
    sectorEs: "Automotriz / Autopartes y Accesorios",
    brand: ["VPS"],
    logo: vpsEquipment,
    url: "https://www.vps-equipment.com",
    catalogUrl: "https://drive.google.com/file/d/1q0DsRElI1FvOYttvvwbWmM2TStqRIu3w/view?usp=sharing",
    description: "Auxiliary transmission for trucks and heavy-duty vehicles.",
    descriptionEs: "Transmisión auxiliar para camiones y vehículos pesados."
  },
  {
    sector: "Automotive / Auto Parts and Accessories",
    sectorEs: "Automotriz / Autopartes y Accesorios",
    brand: ["JUNGLE4X4"],
    logo: jungle4x4,
    url: "https://www.bim4x4.com",
    catalogUrl: "https://drive.google.com/file/d/1ffcIaQj_NdRhe--Hg70RFpJrRED3qeEe/view?usp=sharing",
    description: "Off-road and car accessories: front bumper, rear bumper, side step, roll bar, canopy, body kit, roller up.",
    descriptionEs: "Accesorios off-road y para autos: paragolpes, estribos, barras antivuelco, carrocería y más."
  },
  {
    sector: "Automotive / Auto Parts and Accessories",
    sectorEs: "Automotriz / Autopartes y Accesorios",
    brand: ["ACV"],
    logo: acv,
    url: "http://www.acvrich.com/",
    catalogUrl: "https://drive.google.com/file/d/1hm3-PL9iHQh3PfbKyd9PbnEfyGImea1o/view?usp=sharing",
    description: "Auto spare parts.",
    descriptionEs: "Repuestos y autopartes."
  },
  {
    sector: "Automotive / Auto Parts and Accessories",
    sectorEs: "Automotriz / Autopartes y Accesorios",
    brand: ["OD", "LEO"],
    logo: odAndLeo,
    url: "https://leobattery.com/",
    catalogUrl: "https://drive.google.com/file/d/1w9Qd7GN7avLC3PKR0zVwWlgYAWs7gTst/view?usp=sharing",
    description: "Motorcycle battery.",
    descriptionEs: "Baterías para motocicletas."
  },
  {
    sector: "Automotive / Auto Parts and Accessories",
    sectorEs: "Automotriz / Autopartes y Accesorios",
    brand: ["333", "CJ"],
    logo: cjManufacturing,
    url: "",
    catalogUrl: "https://drive.google.com/file/d/1_-sylm68w3QifcQf45xdtdTKxNAEBqOx/view?usp=sharing",
    description: "Suspension parts: ball joint, tie rod end, rack end, stabilizer link.",
    descriptionEs: "Partes de suspensión: rótulas, terminales, barras estabilizadoras."
  },
  {
    sector: "Automotive / Auto Parts and Accessories",
    sectorEs: "Automotriz / Autopartes y Accesorios",
    brand: ["MCC 4x4"],
    logo: mccIndustrian,
    url: "https://www.mcc4x4.com",
    catalogUrl: "https://share.google/nB5mHhAgf6uOxdKtk",
    description: "4x4 accessories, rocker bullbar.",
    descriptionEs: "Accesorios 4x4, defensas y barras antivuelco."
  },
  // {
  //   sector: "Automotive / Auto Parts and Accessories",
  //   sectorEs: "Automotriz / Autopartes y Accesorios",
  //   brand: ["N.O.K."],
  //   logo: nokEquipment,
  //   url: "",
  //   catalogUrl: "https://drive.google.com/file/d/1YUduQJZBD5tsUKbJVtBXC_8JaTNqnmzn/view?usp=sharing",
  //   description: "Power take off (P.T.O.), auxiliary gearbox for trucks and commercial vehicles.",
  //   descriptionEs: "Tomas de fuerza y cajas auxiliares para camiones y vehículos comerciales."
  // },
  // Electronics / Electrical Products and Parts
  // {
  //   sector: "Electronics / Electrical Products and Parts",
  //   sectorEs: "Electrónica / Productos y Partes Eléctricas",
  //   brand: ["X-PER TECHNIA"],
  //   logo: xPertTechinal,
  //   url: "https://www.xperasia.com",
  //   catalogUrl: "https://drive.google.com/file/d/1l-uojBR09fP_g-PerJm008ef9jaIIYXl/view?usp=sharing",
  //   description: "Air curtain, mist cooling, evaporative air cooler, air curtain for cold room & trucks, stainless steel 316L, air partition, automatic air curtain, mist cooling fan unit, HEPA filter air purifier.",
  //   descriptionEs: "Cortinas de aire, enfriadores evaporativos, ventiladores industriales, purificadores de aire HEPA."
  // },
  // Construction materials / Building materials
  {
    sector: "Construction materials / Building materials",
    sectorEs: "Materiales de construcción",
    brand: ["LUCKY FLAME"],
    logo: luckyFlame,
    url: "https://www.luckyflame.co.th",
    catalogUrl: "https://drive.google.com/file/d/1oUly2gv3VCszqaciGXEEu4dl_1n_eiau/view?usp=sharing",
    description: "Gas cooker, gas regulator.",
    descriptionEs: "Cocinas y reguladores de gas."
  },
  {
    sector: "Construction materials / Building materials",
    sectorEs: "Materiales de construcción",
    brand: ["SPR"],
    logo: spr,
    url: "https://www.suparich.co.th/th",
    catalogUrl: "https://drive.google.com/file/d/1v6QEv10fjsuELQAFZ8yj4bbAa5TZ0DGI/view?usp=sharing",
    description: "Steel door, fire proof steel door, roll up fire resistant doors, blast resistant doors, prefabricated toilet partitions.",
    descriptionEs: "Puertas de acero, puertas ignífugas, puertas enrollables, tabiques y divisores prefabricados."
  },
  // Machinery / Mechanical equipment
  {
    sector: "Machinery / Mechanical equipment",
    sectorEs: "Maquinaria / Equipos mecánicos",
    brand: ["INNOVEK ASIA"],
    logo: innovekAsia,
    url: "https://www.innovek.co.th",
    catalogUrl: "https://drive.google.com/file/d/1XuT7tbdIFMgu5BArdbW4dp8PRdWgca-i/view?usp=sharing",
    description: "Cooling tower: one-stop service cooling tower with energy saving and zero emissions.",
    descriptionEs: "Torres de enfriamiento industriales, eficiencia energética y cero emisiones."
  },
  {
    sector: "Construction materials / Building materials",
    sectorEs: "Materiales de construcción",
    brand: ["MR.WHEEL"],
    logo: mrWheel,
    url: "https://www.thanedproducts.com/",
    catalogUrl: "https://drive.google.com/file/d/1HwUDZFhdDQpbwTn9yDgqijN46KlrOig_/view?usp=sharing",
    description: "Industry casters and wheels for automotive, food, textile, construction. Nylon/polyurethane casters, scaffold wheels.",
    descriptionEs: "Ruedas industriales para automotriz, alimentos, textil y construcción. Ruedas de nylon y poliuretano."
  }
];

export { thaiDelegationList2025Industry }